import { atom } from 'recoil';
import { FilterDef } from '../../../../constants/FinanceModels';

export const STATE_TABLE_UPDATING = atom<boolean>({
    key: "payments-paymentrequest-state-table-updating",
    default: false
});

export const STATE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'payments-paymentrequest-state-active-filters',
    default: []
});

export const STATE_MODAL_UPDATING = atom<boolean>({
    key: "payments-paymentrequest-state-modal-updating",
    default: false
});

